// Zone classifications and their default annual lease prices.
// Used by the zone create form and the Zone Management edit dialog.
export const ZONE_CLASSES = [
  { name: "Standard", fee: 99 },
  { name: "Premium", fee: 199 },
  { name: "Elite", fee: 299 },
];

export const CLASS_FEE = ZONE_CLASSES.reduce((m, c) => ({ ...m, [c.name]: c.fee }), {});
